import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { MessageCircle, Phone, Mail, MapPin } from 'lucide-react';
import { openTawktrikChat } from '../utils/chatUtils';

const LPHeader = ({ onOpenModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll to show/hide top strip
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Bar Strip */}
      <div className={`bg-[#FFB400] transition-all duration-300 ${isScrolled ? 'hidden' : 'block'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center py-2">
            <div className="flex items-center space-x-6 text-[#2B0A12] text-sm">
              <a href="tel:+12139732126" className="flex items-center space-x-2 hover:text-[#2B0A12]/80 transition-colors">
                <Phone className="h-4 w-4" />
                <span className="hidden sm:inline">+1 (213) 973-2126</span>
              </a>
              <a href="mailto:info@trademarkessential.com" className="flex items-center space-x-2 hover:text-[#2B0A12]/80 transition-colors max-[664px]:hidden">
                <Mail className="h-4 w-4" />
                <span>info@trademarkessential.com</span>
              </a>
              <div className="flex items-center space-x-2 max-[991px]:hidden">
                <MapPin className="h-4 w-4" />
                <span>7060 Hollywood Blvd
Los Angeles, CA 90028</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`bg-white shadow-md sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'top-0' : 'top-8'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-4">
          <div className="flex items-center justify-between gap-2">
          {/* Logo - Responsive sizing */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src="/assets/img/brand/logo-dark.png" 
              alt="Trademark Essential Logo" 
              className="h-8 md:h-10 w-auto"
            />
          </div>

          {/* Buttons - Responsive */}
          <div className="flex items-center gap-2">
            {/* Register Button - Responsive text */}
            <Button
              onClick={() => onOpenModal && onOpenModal('Register My Trademark - Header')}
              className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold text-xs sm:text-sm md:text-base px-2 sm:px-4 md:px-6 py-1.5 md:py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
            >
              <span className="hidden sm:inline">Register My Trademark</span>
              <span className="sm:hidden">Register</span>
            </Button>
            
            {/* Chat Button - Hidden on mobile, visible on desktop */}
            <Button
              onClick={openTawktrikChat}
              variant="outline"
              className="hidden lg:flex border-2 border-[#D72638] text-[#D72638] hover:bg-[#D72638] hover:text-white font-semibold px-6 py-2 rounded-lg transition-all duration-300 items-center space-x-2"
            >
              <MessageCircle className="h-4 w-4" />
              <span>Chat Now</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
    </>
  );
};

export default LPHeader;
